const links = {
  "links.CLI_repository": "https://cli.bnpp.platform.sh",
  "links.blackfire.connect": "https://blackfire.io/session/connect/bnpp"
};

export default links;
